// The card's aggregator: the period's games by result. Registered with
// the game store by this plugin's setup; the store runs it over the last
// 30 days.
import { ResultsAccumulator, type ResultCounts } from '@chess/api-insights';
import { aggregatorId, type Accumulator, type Aggregator } from '@chess/api-model';

export class ResultsAggregator implements Aggregator<ResultCounts> {
  readonly id = aggregatorId('results');

  start(): Accumulator<ResultCounts> {
    return new ResultsAccumulator();
  }
}
